module.exports = __webpack_public_path__ + "static/media/hero-large.bf6cc509.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/dashboard/hero-large.jpg
// module id = 374
// module chunks = 0